module.exports = __webpack_public_path__ + "img/029.737dbef7.jpg";